import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const UploadSettings = ({ settings, onSettingsChange }) => {
  const qualityOptions = [
    { value: 'original', label: 'Original Quality', description: 'No compression applied' },
    { value: 'high', label: 'High Quality', description: '90% quality, minimal compression' },
    { value: 'medium', label: 'Medium Quality', description: '75% quality, balanced compression' },
    { value: 'low', label: 'Low Quality', description: '60% quality, maximum compression' },
  ];

  const folderOptions = [
    { value: 'root', label: 'Root Directory', description: '/' },
    { value: 'images', label: 'Images', description: '/images/' },
    { value: 'videos', label: 'Videos', description: '/videos/' },
    { value: 'documents', label: 'Documents', description: '/documents/' },
    { value: 'archives', label: 'Archives', description: '/archives/' },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Settings" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">Upload Settings</h3>
      </div>
      <div className="space-y-6">
        <Select
          label="Image Quality"
          description="Compression level for uploaded images"
          options={qualityOptions}
          value={settings?.imageQuality}
          onChange={(value) => onSettingsChange({ ...settings, imageQuality: value })}
        />

        <Select
          label="Destination Folder"
          description="Target folder in S3 bucket"
          options={folderOptions}
          value={settings?.destinationFolder}
          onChange={(value) => onSettingsChange({ ...settings, destinationFolder: value })}
        />

        <div className="space-y-3">
          <Checkbox
            label="Auto-organize by file type"
            description="Automatically sort files into type-specific folders"
            checked={settings?.autoOrganize}
            onChange={(e) => onSettingsChange({ ...settings, autoOrganize: e?.target?.checked })}
          />

          <Checkbox
            label="Generate thumbnails"
            description="Create thumbnail versions for images"
            checked={settings?.generateThumbnails}
            onChange={(e) => onSettingsChange({ ...settings, generateThumbnails: e?.target?.checked })}
          />

          <Checkbox
            label="Overwrite existing files"
            description="Replace files with the same name"
            checked={settings?.overwriteExisting}
            onChange={(e) => onSettingsChange({ ...settings, overwriteExisting: e?.target?.checked })}
          />

          <Checkbox
            label="Preserve file metadata"
            description="Keep original file creation and modification dates"
            checked={settings?.preserveMetadata}
            onChange={(e) => onSettingsChange({ ...settings, preserveMetadata: e?.target?.checked })}
          />
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={16} className="text-primary flex-shrink-0 mt-0.5" />
            <div className="text-xs text-muted-foreground">
              <p className="font-medium text-foreground mb-1">Upload Guidelines</p>
              <ul className="space-y-1 list-disc list-inside">
                <li>Maximum file size: 100MB per file</li>
                <li>Batch upload limit: 50 files at once</li>
                <li>Supported formats: Images, Videos, Documents, Archives</li>
                <li>Files are scanned for viruses before upload</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadSettings;